import App from './Header-v2.svelte';

const app = new App();

export default app;
